import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './styles/styles.scss'

import { AuthProvider, setupAxios } from './modules/auth'
import { Chart, registerables } from 'chart.js'

import { AppRoutes } from './routing/AppRoutes'
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
import { Provider } from 'react-redux'
import axios from 'axios'
import { createRoot } from 'react-dom/client'
import { store } from './framework/services/store'

/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <MetronicI18nProvider>
      <Provider store={store}>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
      </Provider>
    </MetronicI18nProvider>
  )
}


